<template>

    <Page class="!max-w-[80%]">

        <div class="flex flex-col items-center 2xl:mb-2 -mt-6 2xl:-mt-24">
            <Image src="/History/connected-vehicles-text.png" class="h-16 2xl:h-24" />
        </div>

        <div class="grid grid-cols-2 justify-center w-full 2xl:text-2xl mb-5 2xl:mb-8">
            <h2 class="text-center underline" style="text-underline-offset: 3px;"><strong class="font-semibold">Mark Lancaster</strong> - Founder &amp; CEO</h2>
            <h2 class="text-center underline" style="text-underline-offset: 3px;"><strong class="font-semibold">Craig Compton</strong> - Founder &amp; CTO</h2>
        </div>

        <div class="flex flex-col gap-4 2xl:gap-5 2xl:text-xl text-justify">
            <p>
                Connected Vehicles is <span class="text-[#2b85be] font-semibold">modernizing automotive retention</span> through data-driven solutions 
                and consumer loyalty products to enhance dealer revenue and raise retention. 
            </p>

            <p>
                With <span class="text-[#2b85be] font-semibold">Carbucks REWARDS</span> and <span class="text-[#2b85be] font-semibold">Carbucks PROTECT</span>, we provide dealerships with powerful 
                programs to increase profitability while improving customer experience and goodwill.
            </p>
        
            <p>
                Our vision is to transform the automotive industry by giving every driver access to tailored, 
                convenient, and affordable automotive services, <span class="text-[#2b85be] font-semibold">using cutting-edge telematics and mobile 
                technology</span> to deliver customized experiences that enhance safety, satisfaction, and long-term revenue.
            </p>
            
            <p>
                The company's goal is to become the leading global provider of personalised and relevant automotive 
                experiences, by <span class="text-[#2b85be] font-semibold">continuously innovating and expanding offerings</span> to meet the evolving 
                needs of dealers and their customers.
            </p>
        </div>

    </Page>

</template>